import { ScoutingPhoto } from '../types';

export const getPhotoDisplayUrl = (photo: ScoutingPhoto, useThumbnail = false): string => {
  if (useThumbnail) {
    return photo.thumbnail_url || photo.image_url || photo.storage_url;
  }
  return photo.image_url || photo.thumbnail_url || photo.storage_url;
};

export const isPhotoDisplayUrlExpired = (photo: ScoutingPhoto, bufferSeconds = 15): boolean => {
  if (!photo.display_url_expires_at) return false;
  const expiresAtMs = new Date(photo.display_url_expires_at).getTime();
  if (!Number.isFinite(expiresAtMs)) return false;
  return Date.now() >= expiresAtMs - Math.max(0, bufferSeconds) * 1000;
};
